module.exports = __webpack_public_path__ + "static/media/star-background.527808a7.jpg";